export const MIN_XBOX_VERSION = [3, 3, 0];

export const UNSUPPORTED_FIRMWARE = "This hub has HubPilot firmware, which is no longer supported. Install the official Pybricks firmware (see Firmware setup), then press Drive again.";

// Official Pybricks reports e.g. "v3.6.1". HubPilot/HubSync builds ("+hubpilot.0.1.0") must be replaced first.
export function describeFirmware(raw) {
  if (!raw) return { kind: "unknown", label: "Unknown firmware", version: "", xbox: null, unsupported: false };
  const unsupported = /hubpilot|hubsync/i.test(raw);
  const m = raw.match(/(\d+)\.(\d+)\.(\d+)/);
  const parts = m ? m.slice(1).map(Number) : null;
  let xbox = null;
  if (parts) {
    xbox = parts[0] > MIN_XBOX_VERSION[0] || (parts[0] === MIN_XBOX_VERSION[0] && parts[1] >= MIN_XBOX_VERSION[1]);
  }
  return {
    kind: unsupported ? "unsupported" : "pybricks",
    label: unsupported ? "HubPilot firmware (no longer supported)" : "Pybricks firmware",
    version: parts ? `v${parts.join(".")}` : raw,
    xbox,
    unsupported,
  };
}
